/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListAssetIncidentsMetaDto } from './ListAssetIncidentsMetaDto';
import {
    ListAssetIncidentsMetaDtoFromJSON,
    ListAssetIncidentsMetaDtoFromJSONTyped,
    ListAssetIncidentsMetaDtoToJSON,
    ListAssetIncidentsMetaDtoToJSONTyped,
} from './ListAssetIncidentsMetaDto';
import type { AssetDetailIncidentResponseDto } from './AssetDetailIncidentResponseDto';
import {
    AssetDetailIncidentResponseDtoFromJSON,
    AssetDetailIncidentResponseDtoFromJSONTyped,
    AssetDetailIncidentResponseDtoToJSON,
    AssetDetailIncidentResponseDtoToJSONTyped,
} from './AssetDetailIncidentResponseDto';

/**
 * 
 * @export
 * @interface ListAssetIncidentsResponseDto
 */
export interface ListAssetIncidentsResponseDto {
    /**
     * 
     * @type {Array<AssetDetailIncidentResponseDto>}
     * @memberof ListAssetIncidentsResponseDto
     */
    data: Array<AssetDetailIncidentResponseDto>;
    /**
     * 
     * @type {ListAssetIncidentsMetaDto}
     * @memberof ListAssetIncidentsResponseDto
     */
    meta: ListAssetIncidentsMetaDto;
}

/**
 * Check if a given object implements the ListAssetIncidentsResponseDto interface.
 */
export function instanceOfListAssetIncidentsResponseDto(value: object): value is ListAssetIncidentsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListAssetIncidentsResponseDtoFromJSON(json: any): ListAssetIncidentsResponseDto {
    return ListAssetIncidentsResponseDtoFromJSONTyped(json, false);
}

export function ListAssetIncidentsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAssetIncidentsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(AssetDetailIncidentResponseDtoFromJSON)),
        'meta': ListAssetIncidentsMetaDtoFromJSON(json['meta']),
    };
}

export function ListAssetIncidentsResponseDtoToJSON(json: any): ListAssetIncidentsResponseDto {
    return ListAssetIncidentsResponseDtoToJSONTyped(json, false);
}

export function ListAssetIncidentsResponseDtoToJSONTyped(value?: ListAssetIncidentsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(AssetDetailIncidentResponseDtoToJSON)),
        'meta': ListAssetIncidentsMetaDtoToJSON(value['meta']),
    };
}

